export enum VerificationRequestLogoType {
    Desktop = 1,
    Mobile = 2
}